import React, { useEffect } from 'react';
import qs from 'qs';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Hits,
  Snippet,
  Configure,
  connectSearchBox,
  connectStateResults,
} from 'react-instantsearch-dom';
import { Link } from 'react-router-dom';
import { Input } from 'antd';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import { withApollo } from '@apollo/react-hoc';
import ProductLayout from '$components/layout/ProductLayout';
import getPlaceholder from '$components/student/Search/getPlaceholder';
import Well from '$components/ProductDashboard/Well';
import history from '$lib/history';
import { track } from '$lib/tracking';

import styles from './styles.scss';

const ALGOLIA_APP_ID = process.env.ALGOLIA_APP_ID; // eslint-disable-line prefer-destructuring
const ALGOLIA_SEARCH_API_KEY = process.env.ALGOLIA_SEARCH_API_KEY; // eslint-disable-line prefer-destructuring

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);

const ParentNames = ({ hit }) => {
  const { parentNames } = hit;
  return (
    <div className={styles.parentNames}>
      {parentNames.map((parentName) => (
        <div key={parentName}>In <em className={styles.parentName}>{parentName}</em></div>
      ))}
    </div>
  );
};

const Hit = (props) => {
  const { hit } = props;
  const { name, path } = hit;

  return (
    <div className={styles.hit}>
      <Link to={path} className={styles.hitName}>
        {name}
      </Link>
      <ParentNames hit={hit} />
      <Snippet attribute="sanitizedText" hit={hit} className={styles.hitText} />
    </div>
  );
};

const Results = connectStateResults(({ searchResults, children }) =>
  searchResults && searchResults.nbHits !== 0 ? (
    children
  ) : (
    <div className={styles.noResults}>
      Sorry, we couldn&apos;t find anything matching your search.
    </div>
  )
);
const SearchBox = (props) => {
  const { location, placeholder, refine } = props;
  const { search } = location;
  const locationSearchQuery = search.substring(1);
  const parsed = qs.parse(locationSearchQuery);
  const { query: initialQuery } = parsed;

  useEffect(() => {
    if (initialQuery) {
      refine(initialQuery);
    }
  }, []);

  const handleSearch = (query) => {
    const { product } = props;
    const { slug: productSlug } = product;
    track('Search | Searched', {
      productSlug,
      query,
    });
    const route = `${reverse(routes.study.search, {
      productSlug,
    })}?query=${encodeURIComponent(query)}`;
    history.replace(route);

    refine(query);
  };

  return (
    <Input.Search
      data-aaa="search"
      defaultValue={initialQuery}
      placeholder={placeholder}
      onSearch={handleSearch}
      enterButton
    />
  );
};

const DebouncedSearchBox = connectSearchBox(SearchBox);

const Search = (props) => {
  const { location, product } = props;
  const { slug: productSlug } = product;
  const placeholder = getPlaceholder(product);
  return (
    <div className={styles.layout}>
      <div className={styles.title}>Textbook search</div>
      <InstantSearch indexName="contents" searchClient={searchClient}>
        <Configure
          hitsPerPage={8}
          filters={`productSlug:${productSlug}`}
          offset={0}
          length={10}
        />
        <DebouncedSearchBox
          delay={1000}
          placeholder={placeholder}
          location={location}
          product={product}
        />
        <Results>
          <Hits hitComponent={Hit} />
        </Results>
      </InstantSearch>
    </div>
  );
};

const SearchWrapper = ({ client, currentUser, location, match }) => (
  <ProductLayout currentUser={currentUser} location={location} match={match}>
    {({ product }) => (
      <Well>
        <Search client={client} product={product} location={location} match={match} />
      </Well>
    )}
  </ProductLayout>
);

export default withApollo(SearchWrapper);
